module.exports = __webpack_public_path__ + "static/media/oh_pack3_sample000_0001.4f0ff331.png";